import { useState } from "react"
import { Modal, Table, Button, message, Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import { MapPin, Phone, Building, Check, UserPlus } from "lucide-react"
import "../assets/styles/ChooseVetModal.css" 

const ChooseVetModal = ({ visible, onClose, veterinaries, onJoin }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState({})

  const handleJoin = async (veterinaryId) => {
    try {
      setLoading((prev) => ({ ...prev, [veterinaryId]: true }))
      if (onJoin) {
        await onJoin(veterinaryId)
      }
      message.success(t("veterinaryList.joinSuccess") || "Successfully joined veterinary clinic")
    } catch (error) {
      console.error("Error joining veterinary:", error)
      message.error(t("veterinaryList.joinError") || "Failed to join veterinary clinic")
    } finally {
      setLoading((prev) => ({ ...prev, [veterinaryId]: false }))
    }
  }

  const columns = [
    {
      title: t("veterinaryList.name") || "Name",
      dataIndex: "legalName",
      key: "name",
      render: (text, record) => (
        <div className="vet-name-cell">
          {/* <Avatar src={record.logo || "/placeholder-logo.png"} size={40} shape="square" className="vet-logo" /> */}
          <div className="vet-name-container">
            <span className="vet-name">{text}</span>
            {record.active && (
              <Tooltip title={t("veterinaryList.active") || "Active"}>
                <span className="active-badge">
                  <Check size={12} />
                </span>
              </Tooltip>
            )}
          </div>
        </div>
      ),
    },
    {
      title: t("veterinaryList.address") || "Address",
      dataIndex: "address",
      key: "address",
      render: (text) => (
        <div className="vet-info-cell">
          <MapPin size={16} className="vet-info-icon" />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: t("veterinaryList.phoneNumber") || "Phone Number",
      dataIndex: "phoneNumber",
      key: "phone_number",
      render: (text) => (
        <div className="vet-info-cell">
          <Phone size={16} className="vet-info-icon" />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: t("veterinaryList.actions") || "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => handleJoin(record.id)}
          loading={loading[record.id]}
          className="join-button"
          icon={<UserPlus size={16} />}
        >
          {t("veterinaryList.join") || "Join"}
        </Button>
      ),
    },
  ]

  return (
    <Modal
      title={
        <div className="modal-title">
          <Building size={20} />
          <span>{t("veterinaryList.title") || "Veterinary Clinics"}</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      className="vet-selection-modal"
    >
      <div className="modal-description">{t("veterinaryList.description") || "Select a veterinary clinic to join"}</div>
      <Table
        columns={columns}
        dataSource={veterinaries || []}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        className="vet-table"
        rowClassName="vet-table-row"
      />
    </Modal>
  )
}

export default ChooseVetModal
